export default {"src":"/_next/static/media/plus-icon.8ca49d54.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};